import { render, staticRenderFns } from "./activities-slider-row.vue?vue&type=template&id=83721556&scoped=true&"
import script from "./activities-slider-row.vue?vue&type=script&lang=js&"
export * from "./activities-slider-row.vue?vue&type=script&lang=js&"
import style0 from "./activities-slider-row.vue?vue&type=style&index=0&id=83721556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83721556",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83721556')) {
      api.createRecord('83721556', component.options)
    } else {
      api.reload('83721556', component.options)
    }
    module.hot.accept("./activities-slider-row.vue?vue&type=template&id=83721556&scoped=true&", function () {
      api.rerender('83721556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/activities-slider-row.vue"
export default component.exports